<template>
  <div class="flex width-100">
    <div class="width-100">
      <h2>Test Comparison</h2>

      <GridContainer
        class="align-left"
      >
        <div class="width-100">
          <h3>Decision Making</h3>
          <el-table
            :data="gameDecisionMaking"
            border
            stripe
            highlight-current-row
          >
            <el-table-column label="Game">
              <el-table-column label="Scenario 1">
                <el-table-column
                  prop="game.scenario1.option"
                  label="Option"
                />
                <el-table-column
                  prop="game.scenario1.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.game.scenario1.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 2">
                <el-table-column
                  prop="game.scenario2.option"
                  label="Option"
                />
                <el-table-column
                  prop="game.scenario2.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.game.scenario2.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 3">
                <el-table-column
                  prop="game.scenario3.option"
                  label="Option"
                />
                <el-table-column
                  prop="game.scenario3.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.game.scenario3.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 4">
                <el-table-column
                  prop="game.scenario4.option"
                  label="Option"
                />
                <el-table-column
                  prop="game.scenario4.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.game.scenario4.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div class="width-100">
          <el-table
            :data="sjtDecisionMaking"
            border
            stripe
            highlight-current-row
          >
            <el-table-column label="SJT">
              <el-table-column label="Scenario 1">
                <el-table-column
                  prop="sjt.scenario1.option"
                  label="Option"
                />
                <el-table-column
                  prop="sjt.scenario1.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.sjt.scenario1.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 2">
                <el-table-column
                  prop="sjt.scenario2.option"
                  label="Option"
                />
                <el-table-column
                  prop="sjt.scenario2.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.sjt.scenario2.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 3">
                <el-table-column
                  prop="sjt.scenario3.option"
                  label="Option"
                />
                <el-table-column
                  prop="sjt.scenario3.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.sjt.scenario3.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Scenario 4">
                <el-table-column
                  prop="sjt.scenario4.option"
                  label="Option"
                />
                <el-table-column
                  prop="sjt.scenario4.count"
                  label="Answers"
                >
                  <template slot-scope="scope">
                    <b>{{ scope.row.sjt.scenario4.count }}</b>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </GridContainer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TestComparison',
  data() {
    return {
      sjtDecisionMaking: [
        {
          game: {
            scenario1: { option: 'A', order: 1, count: 12 },
            scenario2: { option: 'A', order: 1, count: 8 },
            scenario3: { option: 'A', order: 1, count: 9 },
            scenario4: { option: 'A', order: 1, count: 7 }
          },
          sjt: {
            scenario1: { option: 'A', order: 1, count: 13 },
            scenario2: { option: 'A', order: 1, count: 7 },
            scenario3: { option: 'A', order: 1, count: 10 },
            scenario4: { option: 'A', order: 1, count: 6 }
          }
        },
        {
          game: {
            scenario1: { option: 'B', order: 2, count: 9 },
            scenario2: { option: 'B', order: 2, count: 7 },
            scenario3: { option: 'B', order: 2, count: 10 },
            scenario4: { option: 'B', order: 2, count: 10 }
          },
          sjt: {
            scenario1: { option: 'B', order: 2, count: 10 },
            scenario2: { option: 'B', order: 2, count: 7 },
            scenario3: { option: 'B', order: 2, count: 8 },
            scenario4: { option: 'B', order: 2, count: 11 }
          }
        },
        {
          game: {
            scenario1: { option: 'C', order: 3, count: 10 },
            scenario2: { option: 'C', order: 3, count: 12 },
            scenario3: { option: 'C', order: 3, count: 6 },
            scenario4: { option: 'C', order: 3, count: 8 }
          },
          sjt: {
            scenario1: { option: 'C', order: 3, count: 11 },
            scenario2: { option: 'C', order: 3, count: 11 },
            scenario3: { option: 'C', order: 3, count: 7 },
            scenario4: { option: 'C', order: 3, count: 7 }
          }
        },
        {
          game: {
            scenario1: { option: 'D', order: 4, count: 17 },
            scenario2: { option: 'D', order: 4, count: 6 },
            scenario3: { option: 'D', order: 4, count: 6 },
            scenario4: { option: 'D', order: 4, count: 7 }
          },
          sjt: {
            scenario1: { option: 'D', order: 4, count: 16 },
            scenario2: { option: 'D', order: 4, count: 8 },
            scenario3: { option: 'D', order: 4, count: 7 },
            scenario4: { option: 'D', order: 4, count: 6 }
          }
        }
      ],
      gameDecisionMaking: [
        {
          game: {
            scenario1: { option: 'A', order: 1, count: 12 },
            scenario2: { option: 'A', order: 1, count: 8 },
            scenario3: { option: 'A', order: 1, count: 9 },
            scenario4: { option: 'A', order: 1, count: 7 }
          },
          sjt: {
            scenario1: { option: 'A', order: 1, count: 13 },
            scenario2: { option: 'A', order: 1, count: 7 },
            scenario3: { option: 'A', order: 1, count: 10 },
            scenario4: { option: 'A', order: 1, count: 6 }
          }
        },
        {
          game: {
            scenario1: { option: 'B', order: 2, count: 9 },
            scenario2: { option: 'B', order: 2, count: 7 },
            scenario3: { option: 'B', order: 2, count: 10 },
            scenario4: { option: 'B', order: 2, count: 10 }
          },
          sjt: {
            scenario1: { option: 'B', order: 2, count: 10 },
            scenario2: { option: 'B', order: 2, count: 7 },
            scenario3: { option: 'B', order: 2, count: 8 },
            scenario4: { option: 'B', order: 2, count: 11 }
          }
        },
        {
          game: {
            scenario1: { option: 'C', order: 3, count: 10 },
            scenario2: { option: 'C', order: 3, count: 12 },
            scenario3: { option: 'C', order: 3, count: 6 },
            scenario4: { option: 'C', order: 3, count: 8 }
          },
          sjt: {
            scenario1: { option: 'C', order: 3, count: 11 },
            scenario2: { option: 'C', order: 3, count: 11 },
            scenario3: { option: 'C', order: 3, count: 7 },
            scenario4: { option: 'C', order: 3, count: 7 }
          }
        },
        {
          game: {
            scenario1: { option: 'D', order: 4, count: 17 },
            scenario2: { option: 'D', order: 4, count: 6 },
            scenario3: { option: 'D', order: 4, count: 6 },
            scenario4: { option: 'D', order: 4, count: 7 }
          },
          sjt: {
            scenario1: { option: 'D', order: 4, count: 16 },
            scenario2: { option: 'D', order: 4, count: 8 },
            scenario3: { option: 'D', order: 4, count: 7 },
            scenario4: { option: 'D', order: 4, count: 6 }
          }
        }
      ]
    }
  },
  created() {
    // this.getAnswers()
  },
  methods: {
    groupByKey(arr) {
      return arr.reduce(function(r, a) {
        r[a.optionOrdering] = r[a.optionOrdering] || []
        r[a.optionOrdering].push(a)
        return r
      }, Object.create(null))
    },
    getSjtAnswers(arr, softSkill) {
      let formatted = []
      let groupedByOption = []
      arr.forEach(inv => {
        groupedByOption.push(this.groupByKey(inv.answersDetailed))
      })

      for (let index = 1; index < 5; index++) {
        let obj = {
          sjt: {}
        }
        if (index === 1) {
          obj.sjt = {
            scenario1: { option: 'A', order: 1, count: 0 },
            scenario2: { option: 'A', order: 1, count: 0 },
            scenario3: { option: 'A', order: 1, count: 0 },
            scenario4: { option: 'A', order: 1, count: 0 }
          }
        }
        if (index === 2) {
          obj.sjt = {
            scenario1: { option: 'B', order: 2, count: 0 },
            scenario2: { option: 'B', order: 2, count: 0 },
            scenario3: { option: 'B', order: 2, count: 0 },
            scenario4: { option: 'B', order: 2, count: 0 }
          }
        }
        if (index === 3) {
          obj.sjt = {
            scenario1: { option: 'C', order: 3, count: 0 },
            scenario2: { option: 'C', order: 3, count: 0 },
            scenario3: { option: 'C', order: 3, count: 0 },
            scenario4: { option: 'C', order: 3, count: 0 }
          }
        }
        if (index === 4) {
          obj.sjt = {
            scenario1: { option: 'D', order: 4, count: 0 },
            scenario2: { option: 'D', order: 4, count: 0 },
            scenario3: { option: 'D', order: 4, count: 0 },
            scenario4: { option: 'D', order: 4, count: 0 }
          }
        }
        groupedByOption.forEach(o => {
          if (o[index] !== undefined) {
            o[index].forEach(opt => {
              if (opt.softSkillId === softSkill) {
                let key = opt.optionOrdering
                if (key === 1) {
                  obj.sjt['scenario' + opt.ordering].count++
                }
                if (key === 2) {
                  obj.sjt['scenario' + opt.ordering].count++
                }
                if (key === 3) {
                  obj.sjt['scenario' + opt.ordering].count++
                }
                if (key === 4) {
                  obj.sjt['scenario' + opt.ordering].count++
                }
              }
            })
          }
        })
        formatted.push(obj)
      }
      return formatted
    },
    getGameAnswers(arr, softSkill) {
      let formatted = []
      let groupedByOption = []
      arr.forEach(inv => {
        groupedByOption.push(this.groupByKey(inv.answersDetailed))
      })

      for (let index = 1; index < 5; index++) {
        let obj = {
          game: {}
        }
        if (index === 1) {
          obj.game = {
            scenario1: { option: 'A', order: 1, count: 0 },
            scenario2: { option: 'A', order: 1, count: 0 },
            scenario3: { option: 'A', order: 1, count: 0 },
            scenario4: { option: 'A', order: 1, count: 0 }
          }
        }
        if (index === 2) {
          obj.game = {
            scenario1: { option: 'B', order: 2, count: 0 },
            scenario2: { option: 'B', order: 2, count: 0 },
            scenario3: { option: 'B', order: 2, count: 0 },
            scenario4: { option: 'B', order: 2, count: 0 }
          }
        }
        if (index === 3) {
          obj.game = {
            scenario1: { option: 'C', order: 3, count: 0 },
            scenario2: { option: 'C', order: 3, count: 0 },
            scenario3: { option: 'C', order: 3, count: 0 },
            scenario4: { option: 'C', order: 3, count: 0 }
          }
        }
        if (index === 4) {
          obj.game = {
            scenario1: { option: 'D', order: 4, count: 0 },
            scenario2: { option: 'D', order: 4, count: 0 },
            scenario3: { option: 'D', order: 4, count: 0 },
            scenario4: { option: 'D', order: 4, count: 0 }
          }
        }
        groupedByOption.forEach(o => {
          if (o[index] !== undefined) {
            o[index].forEach(opt => {
              if (opt.softSkillId === softSkill) {
                let key = opt.optionOrdering
                if (key === 1) {
                  obj.game['scenario' + opt.ordering].count++
                }
                if (key === 2) {
                  obj.game['scenario' + opt.ordering].count++
                }
                if (key === 3) {
                  obj.game['scenario' + opt.ordering].count++
                }
                if (key === 4) {
                  obj.game['scenario' + opt.ordering].count++
                }
              }
            })
          }
        })
        formatted.push(obj)
      }
      return formatted
    },
    getAnswers() {
      const sjtParams = {
        size: 60,
        positionId: 5238362,
        includeanswers: true,
        detailedanswers: true
      }

      const gameParams = {
        size: 60,
        positionId: 5238361,
        includeanswers: true,
        detailedanswers: true
      }

      this.$store.dispatch('getAssessments', { params: sjtParams })
        .then(res => {
          this.sjtDecisionMaking = this.getSjtAnswers(res.data.content, 4)
        })

      this.$store.dispatch('getAssessments', { params: gameParams })
        .then(res => {
          this.gameDecisionMaking = this.getGameAnswers(res.data.content, 4)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .width-50 {
    width: 50%;
  }

  .align-left {
    margin-left: 0;
  }

  .vertical-divider {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: - ($-padding-unit * 4);
      width: 1px;
      background-color: $-color-silver;
    }
  }
</style>
